<template>
  <div class="modal fade" :id="id" tabindex="-1" data-bs-backdrop="static" data-bs-keyboard="false" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('mail.save_imap_identify') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <Input
                container-class="form-group mb-5"
                :name="`fullname`+id"
                type="text"
                :label="$t('mail.fullname')"
                :placeholder="$t('mail.fullname')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-lg form-control-solid'"
                size="lg"
                v-model="formData.fullname"
            />
            <Input
                container-class="form-group mb-5"
                :name="`username`+id"
                type="email"
                :label="$t('mail.username')"
                :placeholder="$t('mail.username')"
                labelClass="form-label fs-6 text-black"
                :inputClass="'form-control form-control-lg form-control-solid'"
                size="lg"
                v-model="formData.username"
            />
            <Input
                container-class="form-group"
                :name="`password`+id"
                type="password"
                :label="$t('mail.password')"
                labelClass="form-label fs-6 text-black"
                :placeholder="$t('mail.password')"
                :inputClass="'form-control form-control-lg form-control-solid'"
                size="lg"
                v-model="formData.password"
                    />
          </div>
          <div class="modal-footer">
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingUser"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineProps, watch, defineEmits, onMounted} from "vue";
  import Input from "@/components/Input.vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import RequiredText from "@/components/RequiredText.vue";

  const store = useStore()
  
  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      default: {}
    },
  })

  const isLoadingUser = ref(false)
  const formData = ref({
      username: '',
      fullname: '',
      password: ''
  })

  watch(() => props.user, (value) => {
    if(value) {
      formData.value.username = value.email
      formData.value.fullname = value.fullname
    }
  });


  function closeModal(){
    $('#'+props.id).modal('hide')
    $('.modal-backdrop').remove();
    emits('close')
  }

  const emits = defineEmits(['load', 'close', 'finish'])

  async function submitForm(){
    try {
      isLoadingUser.value = true;

      await store.dispatch('mails/setUserConfig', formData.value).then((res) =>{
        formData.value.password = ''
        emits('load')
        emits('finish')
        $('#'+props.id).modal('toggle')
        window.toastr['success'](i18n.global.t('mail.config_successfully'))
      }) 
    } catch (error) {
    } finally {
      isLoadingUser.value = false;
    }
  }
</script>